import type { Editor } from "@tiptap/core";

export const DocumentPatternSelection = {
	id(editor: Editor, position = editor.state.selection.from) {
		const cursor = editor.state.doc.resolve(position);

		for (const depth of Array.from({ length: cursor.depth }, (_, index) => cursor.depth - index)) {
			if (cursor.node(depth).type.name === "pattern") {
				return cursor.node(depth).attrs.patternId as number;
			}
		}

		return null;
	},

	range(editor: Editor) {
		const { $from, $to } = editor.state.selection;
		const from = $from.depth === 0 ? $from.pos : $from.before(1);
		const to = $to.depth === 0 ? $to.pos : $to.after(1);
		const content = editor.state.doc.slice(from, to).content;
		const allowed = [...content.content].every(
			(node) => node.type.name !== "pattern" && node.type.name !== "pageBreak",
		);

		if (!allowed || content.childCount === 0) {
			return null;
		}

		return { from, to, content: content.toJSON() };
	},
};
